import React from 'react';
import { trackJsError } from '../services/telemetry';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    try { trackJsError(error, { componentStack: info?.componentStack }); } catch (_) {}
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    try { window.location.reload(); } catch (_) {}
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
          <div className="bg-white rounded-xl shadow-lg max-w-lg w-full p-6 text-center">
            <h1 className="text-xl font-bold text-slate-900 mb-2">Oups, un souci…</h1>
            <p className="text-sm text-slate-600 mb-4">
              Une erreur est survenue et a été enregistrée automatiquement.
              Vous pouvez recharger la page pour continuer.
            </p>
            <pre className="text-xs bg-slate-100 rounded p-3 text-left overflow-auto max-h-40 mb-4 text-slate-700">
              {String(this.state.error?.message || this.state.error || 'Unknown error')}
            </pre>
            <button
              onClick={this.handleReset}
              className="px-4 py-2 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700"
              data-testid="error-boundary-reload"
            >
              Recharger la page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
